import React from 'react'

const SummaryItem = ({ label, value }) => {
    return (
        <div className="summary-item">
            <p className="summary-item-label">{label}</p>
            <p className="summary-item-value">{value}</p>
        </div>
    );
}

export default SummaryItem